import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Select, MenuItem, InputLabel, FormControl, Alert } from '@mui/material';
import { SubscriptionPlanInterface } from '../../../interfaces/interfaces';

interface Props {
  open: boolean;
  planToUpdate: SubscriptionPlanInterface | null;
  setPlanToUpdate: React.Dispatch<React.SetStateAction<SubscriptionPlanInterface | null>>;
  onClose: () => void;
  onSave: () => void;
  updateError?: string | null;
  updateSuccess?: string | null;
}

export const AdSpaceSubscriptionPlansUpdateDialog: React.FC<Props> = ({
  open,
  planToUpdate,
  setPlanToUpdate,
  onClose,
  onSave,
  updateError,
  updateSuccess,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>Update Subscription Plan</DialogTitle>
    <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
      {updateError && <Alert severity="error">{updateError}</Alert>}
      {updateSuccess && <Alert severity="success">{updateSuccess}</Alert>}
      <TextField
        label="Plan Name"
        value={planToUpdate?.planName ?? ''}
        onChange={e => setPlanToUpdate(p => p ? { ...p, planName: e.target.value } : p)}
        fullWidth
        margin="dense"
        required
      />
      <TextField
        label="Description"
        value={planToUpdate?.description ?? ''}
        onChange={e => setPlanToUpdate(p => p ? { ...p, description: e.target.value } : p)}
        fullWidth
        margin="dense"
        required
      />
      <TextField
        label="Price"
        type="number"
        value={planToUpdate?.price ?? ''}
        onChange={e => setPlanToUpdate(p => p ? { ...p, price: Number(e.target.value) } : p)}
        fullWidth
        margin="dense"
        required
      />
      <FormControl fullWidth margin="dense">
        <InputLabel id="active-label">Active</InputLabel>
        <Select
          labelId="active-label"
          value={planToUpdate?.active !== undefined ? (planToUpdate.active ? 'yes' : 'no') : 'yes'}
          label="Active"
          onChange={e => setPlanToUpdate(p => p ? { ...p, active: e.target.value === 'yes' } : p)}
        >
          <MenuItem value="yes">Yes</MenuItem>
          <MenuItem value="no">No</MenuItem>
        </Select>
      </FormControl>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button color="primary" onClick={onSave}>Save</Button>
    </DialogActions>
  </Dialog>
);